import { MapPin } from 'lucide-react'

import styles from './SearchDropdown.module.css'

/**
 * SearchResult — single autocomplete row (UI-SPEC §Components 3, lines 271-285).
 *
 *   - 20px `MapPin` icon + 16px Body primary line + 13px Label secondary.
 *   - Min-height 56px, 12px vertical / 16px horizontal padding.
 *   - `role="option"` with `aria-selected={highlighted}` + id for the combobox
 *     active-descendant linkage on the parent input.
 */
export interface SearchResultProps {
  id: string
  label: string
  sublabel?: string
  highlighted?: boolean
  optionId?: string
  onSelect: () => void
}

export function SearchResult({
  label,
  sublabel,
  highlighted,
  optionId,
  onSelect,
}: SearchResultProps) {
  const classes = [styles.row, highlighted ? styles.highlighted : '']
    .filter(Boolean)
    .join(' ')
  return (
    <button
      type="button"
      id={optionId}
      role="option"
      aria-selected={!!highlighted}
      className={classes}
      onClick={onSelect}
    >
      <MapPin size={20} strokeWidth={2} aria-hidden="true" className={styles.icon} />
      <span className={styles.text}>
        <span className={styles.primary}>{label}</span>
        {sublabel && <span className={styles.secondary}>{sublabel}</span>}
      </span>
    </button>
  )
}
